import React from 'react';
import { connect } from 'react-redux';
import './index.scss';

class UpgradeDialog extends React.Component {
  okAction = () => {
    const url = window.location.href.indexOf('sparta') >= 0 ? 'qb://qlight?enablepulldown=false&needtitle=false&titlebartype=1&needshare=false&layoutfromtop=true&hidescrollbar=true&reurl=https%3A%2F%2Ftestugpage.html5.qq.com%2FugWelfare%2Fmake-money-center' : 'qb://qlight?enablepulldown=false&needtitle=false&titlebartype=1&needshare=false&layoutfromtop=true&hidescrollbar=true&reurl=https%3A%2F%2Fugpage.html5.qq.com%2FugWelfare%2Fmake-money-center';
    if (window.browser && window.browser.app && window.browser.app.openUrl) {
      window.browser.app.openUrl(null, null, { url });
    } else {
      return window.location.href = url;
    }
  }

  render() {
    const { okText = '打开新版' } = this.props;
    return (
      <div className="offlineDialog">
        <div className="dialog">
          {/* {from !== 'index' && <div className="close" onClick={this.close}></div>} */ }
          <div className="title">产品升级通知</div>
          <div className="content">
            <div className="inner">
              <div>尊敬的用户，您好！</div>
              <br />
              <p>由于业务调整，福利中心已于<span>2022年1月7日</span>进行产品升级。请点击“打开新版”前往新版福利中心，感谢您一直以来的支持。</p>
              <br />
              <div className="sign">QQ浏览器福利中心团队</div>
            </div>
          </div>
          <div className={ 'btn' } onClick={ this.okAction }>{ okText }</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { dialogs, myIntegral } = state;
  return {
    dialogs,
    myIntegral,
  };
};

export default connect(mapStateToProps)(UpgradeDialog);
